const { default: DataConnector } = require('../../../models/dataConnector');

module.exports = {
    routes: [
        {
            path: '/organization/connectors',
            name: 'dataconnectors',
            meta: {
                permissions: ['organization.responsibles.read'],
                roles: 'connectors'
            },
            component: () => import('./views/index.vue')
        }, {
            path: '/organization/connectors/detail/:id?',
            name: 'dataconnector',
            meta: {
                permissions: ['organization.responsibles.update'],
                roles: 'connectors'
            },
            component: () => import('./views/detail.vue')
        }
    ],
    search: DataConnector.searchConfig,
    itemObject: DataConnector,
    index: {
        route: 'dataconnectors',
        endpoint: 'users',
        filterName: 'dataconnectors',
        intro: 'Beheer hier de dataconnectors van uw organisatie. Data connectors worden gebruikt om data te integreren vanuit externe bronnen.',
        fields: ['id', 'username', 'needsJobTypeUpdate', 'jobTypeConfig{id}', 'assignedRealmRoles{name}', 'engineFlow{id engineId isActive}', 'attributes{description}', 'activeJob{parentTask{id name} project{id name}}'],
        tabs: [{
            path: 'organization',
            text: 'Algemeen',
            permissions: ['organization.general.menu']
        },
        {
            path: 'organizationUsers',
            text: 'Medewerkers',
            permissions: ['organization.employees.menu']
        },
        {
            path: 'organizationContacts',
            text: 'Contacten',
            permissions: ['organization.contacts.menu']
        },
        {
            path: 'dataconnectors',
            text: 'Data connectors',
            permissions: ['organization.responsibles.menu']
        },
        {
            path: 'Teams',
            text: 'Teams',
            permissions: ['organization.teams.menu']
        },
        {
            path: 'organizationIntegrations',
            text: 'Koppelingen',
            permissions: ['organization.integrations.menu']
        },
        {
            path: 'organizationSettings',
            text: 'Instellingen',
            permissions: ['organization.settings.menu']
        }
        ],
        getTitle(item) {
            return item.firstName ? (item.firstName + ' ' + item.lastName) : (item.username ? item.username : '');
        },
        headers: [{
            text: 'Naam',
            value: 'username',
            component: () => import('./../../default/columns/link.vue')
        },
        {
            text: 'Omschrijving',
            value: 'attributes.description.0',
            sortable: false,
            component: () => import('./../../default/columns/link.vue')
        },
        {
            text: 'Project',
            value: 'activeJob.project.name',
            sortable: false,
            component: () => import('./../../default/columns/link.vue')
        },
        {
            text: 'Workflow',
            value: 'activeJob.parentTask.name',
            sortable: false,
            component: () => import('./../../default/columns/link.vue')
        },
        {
            width: 120,
            sortable: false,
            value: "engineActions",
            draggable: false,
            component: () => import('./columns/engine-actions.vue'),
        },
        {
            width: 120,
            sortable: false,
            value: 'actions',
            draggable: false,
            component: () => import('@/components/columns/eod-column-actions.vue'),
        }
        ],
    },
    detail: {
        route: 'organizationUser',
        endpoint: 'user',
        objectName: 'User',
        label: 'Dataconnector',
        fields: ['id', 'companies {id name}', 'jobTypeConfig{id name content}', 'engineFlow{id engineId isActive}', 'name', 'vehicle{id name}', 'acls{id topic acc place}', 'hash', 'isSuper', 'skills{id name threshold}', 'availability{startDateTime endDateTime endTimeUnspecified recurrence}', 'depot{id name description streetAddress postalCode locality region country category}', 'projects {id name company{id}}', 'firstName', 'lastName', 'username', 'email', 'assignedRealmRoles{id name}', 'attributes{phone_number, jobtitle nickname birthdate gender locality locale iban bic postal_code street_address region country notes extra_email extra_phone description}'],
        getTitle(item) {
            return item.firstName ? (item.firstName + ' ' + item.lastName) : (item.username ? item.username : '');
        },
        route: 'dataconnector',
        tabs: [{
            tab: 'general',
            text: 'Algemeen'
        },
        {
            tab: 'configuration',
            text: 'Configuratie'
        },
        {
            tab: 'topics',
            text: 'MQTT Topics',
        },
        {
            tab: 'access',
            text: 'Toegang'
        },
        {
            tab: 'availability',
            text: 'Beschikbaarheid',
            visible(item, eod) {
                return eod.getUser().can('tasks.planning.menu');
            }
        },
        ],
    },
    import: {
        endpoint: 'users',
        objectName: 'User',
    },
}